import { useAuthInfo } from "@propelauth/react";

export const getOrganizationName = (
  authInfo: ReturnType<typeof useAuthInfo>
) => {
  const orgs = authInfo.orgHelper?.getOrgs();
  if (orgs?.length === 1) {
    return orgs[0].orgName;
  }
  return undefined;
};

export const getUserRolesForOrganization = (
  authInfo: ReturnType<typeof useAuthInfo>
) => {
  const orgs = authInfo.orgHelper?.getOrgs();
  if (orgs?.length === 1) {
    const orgId = orgs[0].orgId;
    return (
      authInfo.orgHelper?.getOrg(orgId)?.userInheritedRolesPlusCurrentRole || []
    );
  }
  return [];
};

export const getUserPermissions = (
  authInfo: ReturnType<typeof useAuthInfo>
) => {
  const orgs = authInfo.orgHelper?.getOrgs();
  if (orgs?.length === 1) {
    const orgId = orgs[0].orgId;
    return authInfo.orgHelper?.getOrg(orgId)?.userPermissions || [];
  }
  return [];
};

export const hasRequiredRoles = (
  authInfo: ReturnType<typeof useAuthInfo>,
  requiredRoles: string[]
) => {
  if (!requiredRoles?.length) return true;
  const userRoles = getUserRolesForOrganization(authInfo);
  return requiredRoles.some((role) => userRoles.includes(role));
};

export const hasRequiredPermissions = (
  authInfo: ReturnType<typeof useAuthInfo>,
  requiredPermissions: string[]
) => {
  if (!requiredPermissions?.length) return true;
  const userPermissions = getUserPermissions(authInfo);
  return requiredPermissions.every((permission) =>
    userPermissions.includes(permission)
  );
};
